import React from 'react';
import { ILine } from '../../global';
import { useLinesContext } from '../../contexts/Lines';
import cloneDeep from 'lodash.clonedeep';
import LineInTimeline from './LineInTimeline/LineInTimelineContainer';

function addEditMode(lines: Array<ILine>) {
  const linesUpdated = cloneDeep(lines).map((line) => {
    if (line.editRightSide) {
      line['edit'] = true;
    }
    return line;
  });
  return linesUpdated;
}

export default function LinesPerProduct({
  lines,
  handleLineSubmit,
  addOrDeleteError,
  firstProduct,
}) {
  lines = addEditMode(lines);
  const { timelineInfo } = useLinesContext();

  return (
    <>
      {lines.map((line, i) => {
        const firstLine = i === 0;
        return (
          <LineInTimeline
            key={line.id}
            line={line}
            lineNum={i}
            firstLine={firstLine}
            handleLineSubmit={handleLineSubmit}
            addOrDeleteError={addOrDeleteError}
            firstProduct={firstProduct}
            timelineInfo={timelineInfo}
          />
        );
      })}
    </>
  );
}
